import { Auth } from "../../auth/auth";
import { ProfileData, UserDetails } from "../../common/common.model";
import { fetchProfileData } from "../../services/auth.service";

export const USER_INFO_ACTIONS = {
  SET_USER_INFO_DETAILS: "SET_USER_INFO_DETAILS",
  SET_USER_PROFILE_DATA: "SET_USER_PROFILE_DATA",
  SET_AVAILABLE_ROLES: "SET_AVAIALBLE_ROLES",
};

export const setUserDetailsThunk = () => {
  return async (dispatch: any) => {
    const auth = Auth.getInstance();
    const userMetaData = auth.getUserMetaData();
    let userDetails = new UserDetails(userMetaData);
    dispatch({
      type: USER_INFO_ACTIONS.SET_USER_INFO_DETAILS,
      payload: userDetails,
    });
  };
};

export const fetchAvailableRoles = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: USER_INFO_ACTIONS.SET_AVAILABLE_ROLES,
        payload: {
          loading: true,
          error: {},
        },
      });

      dispatch({
        type: USER_INFO_ACTIONS.SET_AVAILABLE_ROLES,
        payload: {
          loading: false,
          error: {},
          // data: res,
        },
      });
    } catch (err) {}
  };
};

export const fetchProfileDataThunk = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: USER_INFO_ACTIONS.SET_USER_PROFILE_DATA,
        payload: {
          loading: true,
          error: {},
        },
      });
      const response = await fetchProfileData();
      const data = new ProfileData(response);
      dispatch({
        type: USER_INFO_ACTIONS.SET_USER_PROFILE_DATA,
        payload: {
          loading: false,
          data: data,
        },
      });
    } catch (error) {
      dispatch({
        type: USER_INFO_ACTIONS.SET_USER_PROFILE_DATA,
        payload: {
          loading: false,
          error: error,
        },
      });
    }
  };
};
